/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-dialog.vue?vue&type=template&id=002d641b&scoped=true"
import script from "./j-dialog.vue?vue&type=script&lang=js"
export * from "./j-dialog.vue?vue&type=script&lang=js"
import style0 from "./j-dialog.vue?vue&type=style&index=0&id=002d641b&prod&lang=scss&scoped=true"
import style1 from "./j-dialog.vue?vue&type=style&index=1&id=002d641b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002d641b",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import TouchPan from 'quasar/src/directives/TouchPan.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QTooltip,QSeparator,QCardSection});qInstall(component, 'directives', {TouchPan,ClosePopup});
